const transitionQueTitles = {
  1: 'VB-MAPP Milestones Score',
  2: 'VB-MAPP Barriers Score',
  3: 'Negative Behaviors and Instructional Control',
  4: 'Classroom Routines and Group Skills',
  5: 'Social Behavior and Social Play',
  6: 'Independent Academic Work',
  7: 'Generalization of Skills',
  8: 'Range of Reinforcers',
  9: 'Rate of Skill Acquisition',
  10: 'Retention of New Skills',
  11: 'Natural Environment Learning',
  12: 'Transfer Without Training',
  13: 'Adaptability to Change',
  14: 'Spontaneous Behaviors',
  15: 'Self-Directed Leisure Time',
  16: 'General Self-help Skills',
  17: 'Toileting Skills',
  18: 'Eating Skills',
}

export default transitionQueTitles
